import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import './styles.css';
import { useHistory } from 'react-router-dom';
import Loader from '../loader';
import { userStore } from 'store/UserStore';

interface PropsType {}

const SipRedirection: React.FC<PropsType> = () => {
  const [customerId] = userStore((state: any) => [state.customerId]);
  const [countdown, setCountdown] = useState(3);
  const history = useHistory();
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    // Function to parse the URL and extract the ID
    const getIdFromUrl = (url) => {
      const parts = url.split('/');
      if (parts.includes('manualSipData')) {
        return parts[parts.length - 1];
      }
    };
    // Get the current URL
    const currentUrl = window.location.href;

    // Extract the ID from the URL
    const id = getIdFromUrl(currentUrl);
    // Store the ID in local storage
    if (id) {
      localStorage.setItem('manualSipId', id);
    }
    setTimeout(() => {
      if (customerId) {
        history.push('/signin');
      } else {
        history.push('/sip');
      }
    }, 2000);

  }, []);

  return (
    <>
      <div className='loader w-100 d-flex justify-content-center align-items-center'>
        <Loader />
      </div>
    </>
  );
};

export default SipRedirection;
